import { Injectable, isDevMode } from '@angular/core';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';
import { UserService } from '../../user-service/user.service';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { AudiencedDaoService } from 'src/app/dao/audience-dao-service/audience-dao.service';
import { AudienceWifiStats } from 'src/app/models/audience-models/audience-wifi-stats.model';

@Injectable({
  providedIn: 'root'
})
export class AudienceWifiService {

  accessToken = 'WIF';

  constructor(
    private userService: UserService,
    private userStorageService: UserStorageService,
    private audienceDaoService: AudiencedDaoService
  ) { }

  public getWifiStats(datetimeFrom, datetimeTo, centerInternalIdList) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.audienceDaoService.getWifiStats(
        this.userStorageService.getContext(),
        this.userStorageService.getLang(),
        this.userStorageService.getUDID(),
        datetimeFrom,
        datetimeTo,
        centerInternalIdList
      ).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const wifiStats = new AudienceWifiStats();
          Object.assign(wifiStats, o['data']['result']);
          return wifiStats;
        })
      );
    }
    return EMPTY;
  }

}
